import { Injectable } from '@angular/core';
import { CKEditor4 } from 'ckeditor4-angular';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class WordcountService {

  public wordcount = 0;
  public userWords = 0;
  public showWordCount = false;
  public timeout;
  public interval;

  constructor(
    public dataSvc: DataService
  ) {
    this.interval = setInterval(() => {
      this.validateWords();
    }, 500);
  }

  checkWords(event: CKEditor4.EventInfo) {
    this.validateWords();
    event.editor.on("key", function (evt) {
      if (evt.data.keyCode === 1114198 || evt.data.keyCode === 1114129) {
        evt.cancel();
      }
    });
  }

  validateWords() {
    try {
      var data = this.dataSvc.currentQuestion().Result.Selection;  
      if (this.wordcount === undefined || this.wordcount === null) {
        var spwc = (<HTMLSpanElement>document.getElementById("spWc"));
        if (spwc !== null && spwc !== undefined) {
          this.wordcount = parseInt(spwc.innerHTML);
        }
      }
      var spWarning = (<HTMLSpanElement>document.getElementById("spWarning"));
      if (this.wordcount > 0 && this.wordcount !== undefined) {
        this.userWords = data.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/gm, ' ').split(/\s/g).filter(element => {
          if(element === ""){
            return false;
          }else{
            return true;
          }
          
        }).length;

        if(this.dataSvc.currentQuestion().Question.QuestionType === 1024){
          if(data.indexOf("%%ChosenTab") > -1){
            this.userWords = this.userWords - 1;
          }
        }

        //this.userWords = data.split(/\s/g).filter(function(n) { return n != '' }).length;
        var divWordCount = document.getElementById("divWordCount");
        var exceeded = this.userWords >= this.wordcount;  
        if (divWordCount !== undefined) {
          divWordCount.style.display = "block";
          divWordCount.style.color = exceeded ? "red" : "inherit";
          divWordCount.style.fontWeight = exceeded ? "bold" : "normal";
          if (spWarning !== null && spWarning !== undefined) {
            spWarning.style.display = exceeded ? "block" : "none";
          }
        }
      }
    } catch(e) {
      
    }
  }
}